import React from 'react';
import { HeaderText2TW } from '../../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { SpruceHelpInlineLinkTW } from '../../../../../tailwindComponents/links/SpruceHelpInlineLinkTW';

export const DeleteErrorTitle: React.FC = () => {
  return (
    <HeaderText2TW>
      Document was not deleted. Please <SpruceHelpInlineLinkTW /> to submit a request for help.
    </HeaderText2TW>
  );
};
